import { useTranslation } from '@/lib/i18n';
import type { InventoryLocation } from '@/lib/api-admin/types';
import { DataTable, StatusBadge, type DataTableColumn } from '@/components/ui';

interface Props {
  locations: ReadonlyArray<InventoryLocation>;
  isLoading?: boolean;
}

export const InventoryLocationManager = ({ locations, isLoading }: Props) => {
  const { t } = useTranslation('inventory');

  const columns: DataTableColumn<InventoryLocation>[] = [
    {
      key: 'code',
      header: t('inventory.locations.columns.code'),
      cell: (row) => (
        <span className="text-sm font-medium" style={{ color: 'var(--content-strong)' }}>
          {row.code}
        </span>
      ),
    },
    {
      key: 'name',
      header: t('inventory.locations.columns.name'),
      cell: (row) => <span className="text-sm">{row.name}</span>,
    },
    {
      key: 'active',
      header: t('inventory.locations.columns.status'),
      cell: (row) => (
        <StatusBadge
          variant={row.active ? 'success' : 'danger'}
          label={row.active ? t('inventory.locations.active') : t('inventory.locations.inactive')}
        />
      ),
    },
  ];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-16" style={{ color: 'var(--content-muted)' }}>
        {t('inventory.table.loading')}
      </div>
    );
  }

  return (
    <DataTable
      columns={columns}
      rows={locations as InventoryLocation[]}
      rowKey={(row) => row.locationId}
      emptyState={t('inventory.locations.empty')}
    />
  );
};
